import consumer from "./consumer"

consumer.subscriptions.create("DefactoDashboardChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
    console.log("Connected to the Defacto Channel!");
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    $('#r1_pose').text(data.log.r1_pose == true ? 'In Job' : 'Home');
    $('#r1_fault').text(data.log.r1_fault == true ? 'No Fault' : 'Fault');
    $('#r1_mode').text(data.log.r1_mode == true ? 'Auto' : 'Manual');
    $('#r1_chking_status').text(data.log.r1_chking_status);

    var r2_tray = '';
    var tray_component = 0;
    if (data.log.r2_tray == 0) {
      r2_tray = 'Hand wheel Tray';
      tray_component = data.log.r2_tray2_comp
    } else if (data.log.r2_tray == 1) {
      r2_tray = 'Propeller Tray';
      tray_component = data.log.r2_tray3_comp
    } else {
      r2_tray = 'Sand Core Tray';
      tray_component = data.log.r2_tray4_comp
    }
    $('#r2_pose').text(data.log.r2_pose == true ? 'In Job' : 'Home');
    $('#r2_fault').text(data.log.r2_fault == true ? 'No Fault' : 'Fault');
    $('#r2_mode').text(data.log.r2_mode == true ? 'Auto' : 'Manual');
    $('#r2_tool').text(data.log.r2_tool == true ? 'Cutter' : 'Gripper');
    $('#r2_tray').text(r2_tray);
    $('#r2_chking_status').text(tray_component);

    $('#prod_cnt_handwheel').text(data.log.prod_cnt_handwheel);
    $('#prod_cnt_propeller').text(data.log.prod_cnt_propeller);
    $('#prod_cnt_sandcore').text(data.log.prod_cnt_sandcore);
    $('#downtime').text(parseFloat(data.log.downtime / 60).toFixed(2));
    var cell_status_arr = ['Power off', 'Manual', 'Auto', 'Running', 'Fault'];
    $('#cell_status').text(cell_status_arr[data.log.cell_status]);

    var availability = 0;
    var performance = 0;
    var planned_production_time = 7 * 60 * 60;
    var runtime = 0;
    // Availability Time Calculation
    if (window.avlChart) {

      var downtime = data.log.downtime
      runtime = planned_production_time - downtime
      availability = Math.round(runtime / planned_production_time * 100)
      window.avlChart.data.datasets.forEach((dataset) => {
        dataset.data = [availability, 100 - availability];
      });
      window.avlChart.options.elements.center.text = availability + '%';
      window.avlChart.update();
    }

    // Performance Calculation
    var ideal_cycle_time = 30

    if (window.prfrmChart) {
      performance = Math.round(data.log.r2_cycle_count / (runtime / ideal_cycle_time) * 100);
      window.prfrmChart.data.datasets.forEach((dataset) => {
        dataset.data = [performance, 100 - performance];
      });
      window.prfrmChart.options.elements.center.text = performance + '%';
      window.prfrmChart.update();
    }
    var quality = 0;
    var total_count = data.log.prod_cnt_handwheel + data.log.prod_cnt_propeller + data.log.prod_cnt_sandcore
    if (window.qtyChart) {
      quality = Math.round((total_count - data.log.r1_notok_parts / 3) / total_count * 100 || 0);
      window.qtyChart.data.datasets.forEach((dataset) => {
        dataset.data = [quality, 100 - quality];
      });
      window.qtyChart.options.elements.center.text = quality + '%';
      window.qtyChart.update();
    }
    var oee = 0;
    if (window.qtyChart) {
      oee = Math.round((availability * performance * quality) / (100 * 100 * 100) * 100)
      window.oeeChart.data.datasets.forEach((dataset) => {
        dataset.data = [oee, 100 - oee];
      });
      window.oeeChart.options.elements.center.text = oee + '%';
      window.oeeChart.update();
    }
    // Trend Chart Update
    if (window.prodTrndChart) {
      //if (data.trend.length > 0) {
      var time_array = data.trend.map(function (d) {
        var timestamp_string = d.interval_alias;
        var timestamp_string = timestamp_string.substring(0, d.interval_alias.length - 1);
        var time_string = new Date(timestamp_string).toLocaleTimeString();
        time_string = time_string.substring(0, time_string.length - 3)
        return time_string;
      });
      var prod_cnt_handwheel_arr = data.trend.map(function (d, i) {
        return d.prod_cnt_handwheel
      });
      var prod_cnt_propeller_arr = data.trend.map(function (d, i) {
        return d.prod_cnt_propeller

      });
      var prod_cnt_sandcore_arr = data.trend.map(function (d, i) {
        return d.prod_cnt_sandcore
      });
      window.prodTrndChart.data.labels = time_array;
      window.prodTrndChart.data.datasets[0].data = prod_cnt_handwheel_arr;
      window.prodTrndChart.data.datasets[1].data = prod_cnt_propeller_arr;
      window.prodTrndChart.data.datasets[2].data = prod_cnt_sandcore_arr;
      window.prodTrndChart.update();
      //}
    }

    if (window.cycleTimeChart) {
      window.cycleTimeChart.data.datasets[0].data[1] = data.log.r2_cycle_time;
      window.cycleTimeChart.update();
    }

  }
});